import { jsPDF } from 'jspdf';
import { CommonUtils, Roboto } from '@infodata-group/inf-commons';
import html2canvas from 'html2canvas';

export class PlanningToPdf {
  public doc: jsPDF;

  constructor(orientation: 'p' | 'l' = 'l', format: 'a4' | 'a3' | 'a2' = 'a3') {
    this.doc = new jsPDF(orientation, 'pt', format); // A3 size page of PDF
    this.doc.addFileToVFS('Roboto-Regular.ttf', Roboto.regular);
    this.doc.addFileToVFS('Roboto-Bold.ttf', Roboto.bold);
    this.doc.addFont('Roboto-Regular.ttf', 'roboto', 'normal');
    this.doc.addFont('Roboto-Bold.ttf', 'roboto', 'bold');
    this.doc.setFont('roboto');
    this.doc.setFontSize(12);
    this.doc.setLineWidth(0.5);
  }

  async setHtml(container: HTMLElement, headerText?: string) {
    const cloned = container.cloneNode(true) as HTMLElement;
    if (headerText) {
      const headerElement = document.createElement('div');
      headerElement.innerText = headerText;
      headerElement.style.fontSize = '14px';
      headerElement.style.fontWeight = 'bold';
      headerElement.style.borderBottom = '1px solid var(--grey-ee)';
      headerElement.style.height = '30px';
      headerElement.style.display = 'flex';
      headerElement.style.alignItems = 'center';
      headerElement.style.justifyContent = 'center';
      const insertedElement =
        cloned.getElementsByClassName('calendar-grouped')[0];
      if (insertedElement && insertedElement.parentNode) {
        insertedElement.parentNode.insertBefore(headerElement, insertedElement);
        cloned.style.display = 'block';
      }
    }
    const scrollWidth = container.scrollWidth;
    let scrollHeight = container.scrollHeight;
    if (headerText) {
      scrollHeight += 30;
    }
    cloned.style.width = scrollWidth + 'px';
    cloned.style.height = scrollHeight + 'px';
    cloned.style.overflow = 'visible';
    cloned.style.left = '-9999px';
    cloned.style.top = '0';
    cloned.style.zIndex = '-1';
    cloned.style.background = '#fff';
    document.body.appendChild(cloned);
    await new Promise((resolve) => setTimeout(resolve, 100));
    const canvas = await html2canvas(cloned, {
      useCORS: true,
      backgroundColor: CommonUtils.color('white'),
      scale: 2,
    });
    document.body.removeChild(cloned);
    const imgData = canvas.toDataURL('image/png');
    const pageWidth = this.doc.internal.pageSize.getWidth();
    const pageHeight = this.doc.internal.pageSize.getHeight();
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let position = 0;
    while (position < imgHeight) {
      this.doc.addImage(imgData, 'PNG', 0, -position, imgWidth, imgHeight);
      position += pageHeight;
      if (position < imgHeight) this.doc.addPage();
    }
    return this.doc;
  }
}
